/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import { useAmp } from 'next/amp';

const Loading = ({ mobile, desktop }) => {
  const { isMobile } = useDeviceScreen();
  const isAmp = useAmp();
  const width = (isAmp || isMobile) ? mobile.width : desktop.width;
  const height = (isAmp || isMobile) ? mobile.height : desktop.height;

  return !isMobile ? (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="1" y="1" rx="0" ry="0" width="648" height="3" />
      <rect x="1" y="16" rx="0" ry="0" width="434" height="20" />
      <rect x="1" y="56" rx="0" ry="0" width="283" height="259" />
      <rect x="310" y="56" rx="0" ry="0" width="273" height="22" />
      <rect x="310" y="120" rx="5" ry="5" width="317" height="12" />
      <rect x="310" y="140" rx="5" ry="5" width="317" height="12" />
      <rect x="310" y="160" rx="5" ry="5" width="317" height="12" />
      <rect x="310" y="180" rx="5" ry="5" width="317" height="12" />
      <rect x="310" y="200" rx="5" ry="5" width="317" height="12" />
      <rect x="310" y="220" rx="5" ry="5" width="317" height="12" />
      <rect x="311" y="276" rx="0" ry="0" width="327" height="36" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="1" y="1" rx="0" ry="0" width="648" height="3" />
      <rect x="1" y="16" rx="0" ry="0" width="434" height="20" />
      <rect x="1" y="56" rx="0" ry="0" width="283" height="259" />
      <rect x="310" y="56" rx="0" ry="0" width="273" height="22" />
      <rect x="310" y="120" rx="5" ry="5" width="317" height="12" />
      <rect x="310" y="140" rx="5" ry="5" width="317" height="12" />
      <rect x="310" y="160" rx="5" ry="5" width="317" height="12" />
      <rect x="310" y="180" rx="5" ry="5" width="317" height="12" />
      <rect x="310" y="200" rx="5" ry="5" width="317" height="12" />
      <rect x="310" y="220" rx="5" ry="5" width="317" height="12" />
      <rect x="311" y="276" rx="0" ry="0" width="327" height="36" />
    </ContentLoader>
  );
};

Loading.propTypes = {
  mobile: PropTypes.object,
  desktop: PropTypes.object,
};

export default Loading;
